import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>
      Declaration
    </PageTitle>
  </div>
);
